import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Stack, Typography } from '@mui/material';

function NewMailMask(props: any) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap={0.5}
      sx={props.stackSx}
    >
      <CloudUploadOutlinedIcon sx={{ fontSize: 40, color: "#BDBDBD" }} />
      <Typography fontSize={14} fontWeight={600} color="#555" mt={0.5}>
        Upload Image
      </Typography>
      {props.notes && (
        <Typography fontSize={11} color="#BDBDBD" textAlign="center">
          {props.notes}
        </Typography>
      )}
      {props.notes2 && (
        <Typography fontSize={11} color="#BDBDBD" textAlign="center">
          {props.notes2}
        </Typography>
      )}
    </Stack>
  );
}

export default NewMailMask;
